export const clientIds = {
  nwPredictorClientId: 'nw_predictor'
};
